import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {TriggerUtils} from "../trigger/core/TriggerUtils";
import {RewardModel} from "../reward/RewardModel";
import {QuestShow} from "./QuestShow";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {Money} from "@/modules/redactor/models/currency/Money";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";
import { _ } from "core-js";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";


export class QuestModel extends BaseObject {

    constructor() {
        super();
        this._id = null;
        this._key = null;
        this._name = null;

        this._priority = 0;
        this._master = false;

        this._guard = null;
        this._reward = null;

        this._priceComplete = null;

        this._delayOnAvailable = 0;
        this._delayOnComplete = 0;

        this._showOnAvailable = QuestShow.NONE;
        this._showOnComplete = QuestShow.NONE;

        this._triggersAvailable = [];
        this._triggersComplete = [];

        this._mapGroup = null;

        this._chainBack = null;

        this._mapKind  = null;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get mapGroup() {
        return this._mapGroup;
    }

    set mapGroup(value) {
        this._mapGroup = value;
    }

    get mapKind() {
        return this._mapKind;
    }

    set mapKind(value) {
        this._mapKind = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get master() {
        return this._master;
    }

    set master(value) {
        this._master = value;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get priceComplete() {
        return this._priceComplete;
    }

    set priceComplete(value) {
        this._priceComplete = value;
    }

    get delayOnAvailable() {
        return this._delayOnAvailable;
    }

    set delayOnAvailable(value) {
        this._delayOnAvailable = value;
    }

    get delayOnComplete() {
        return this._delayOnComplete;
    }

    set delayOnComplete(value) {
        this._delayOnComplete = value;
    }

    get showOnAvailable() {
        return this._showOnAvailable;
    }

    set showOnAvailable(value) {
        this._showOnAvailable = value;
    }

    get showOnComplete() {
        return this._showOnComplete;
    }

    set showOnComplete(value) {
        this._showOnComplete = value;
    }

    get triggersAvailable() {
        return this._triggersAvailable;
    }

    set triggersAvailable(value) {
        this._triggersAvailable = value;
    }

    get triggersComplete() {
        return this._triggersComplete;
    }

    set triggersComplete(value) {
        this._triggersComplete = value;
    }

    get chainBack() {
        return this._chainBack;
    }

    set chainBack(value) {
        this._chainBack = value;
    }

    valid() {

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.priceComplete && !this.priceComplete.valid()) {
            return false;
        }

        if (!QuestShow.is(this.showOnAvailable)) {
            return false;
        }

        if (!QuestShow.is(this.showOnComplete)) {
            return false;
        }

        if (this.triggersAvailable.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.triggersComplete.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.mapGroup && (MapGroupModel.isGlobal(this.mapGroup) || MapGroupModel.isMain(this.mapGroup))) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new QuestModel());
        } else if (target instanceof QuestModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(QuestModel, {
    _id: alias("id", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _master: alias("master", Schema.primitive()),
    _priority: alias("priority", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _reward: alias("reward", RewardModel.schema()),

    _priceComplete: alias("price_complete", Money.schema()),

    _delayOnAvailable: alias("delay_available", Schema.primitive()),
    _delayOnComplete: alias("delay_complete", Schema.primitive()),

    _showOnAvailable: alias("show_available", QuestShow.schema()),
    _showOnComplete: alias("show_complete", QuestShow.schema()),

    _triggersAvailable: alias("triggers_available", TriggerUtils.schema()),
    _triggersComplete: alias("triggers_complete", TriggerUtils.schema()),
    _mapGroup: alias("map_group", MapGroupModel.schema()),
    _chainBack: alias("chain_back", Schema.primitive()),
    _mapKind: alias("map_kind", MapKindLiteModel.keyOnlySchema()),
});
